import { configureStore } from '@reduxjs/toolkit'
import authReducer from './reducers/auth';
import modalReducer from './reducers/modal';

export default configureStore({
  reducer: {
      auth: authReducer,
      modal: modalReducer,
  },
})